import React from 'react'
import { Modal, useModal, Space, TextHeading, Button } from '@ally/metronome-ui'
import {
  ModalContent,
  StatusTrackerActivity,
} from '@ally/shared-status-tracker'
import styled from 'styled-components'
import { dasherize } from '../../../utils'
import { useHostServices } from '../../../HostServices'

const StyledButton = styled(Button)`
  display: inline;
`
interface ModalProps {
  activity: StatusTrackerActivity
}

const Trigger: React.FC<ModalProps> = ({ activity }) => {
  const { showModal } = useModal()
  const { activityName, statuses } = activity
  const name = activityName === 'ACHTransfer' ? 'AchTransfer' : activityName
  const label = 'View details'
  const allytmln = `${dasherize(name)}-${dasherize(
    statuses[0].status,
  )}-${dasherize(label)}`

  return (
    <StyledButton
      variant="link"
      text={label}
      allytmln={allytmln}
      onClick={showModal}
    />
  )
}

function getModalHeading(activityName: string): string {
  switch (activityName) {
    case 'WireTransfer':
      return 'Wire Transfer'
    case 'CheckOrder':
      return 'Check Order'
    default:
      return 'Transfer'
  }
}

const headingRef = React.createRef<HTMLHeadingElement>()

export const Content: React.FC<ModalProps> = ({ activity }) => {
  const { featureFlags } = useHostServices()
  const isWiresMigrationEnabled = featureFlags.variation(
    'FF_wires-migration-status-tracker',
    false,
  )
  return (
    <>
      <Space mb="md">
        <TextHeading tag="h1" size="md" tabIndex={-1} ref={headingRef}>
          {getModalHeading(activity.activityName)}
        </TextHeading>
      </Space>
      <ModalContent
        isStandaloneModal
        event={activity}
        isWiresMigrationEnabled={isWiresMigrationEnabled}
      />
    </>
  )
}

const StatusTrackerTipsModal: React.FC<ModalProps> = ({ activity }) => {
  return (
    <Modal
      ref={headingRef}
      trigger={<Trigger activity={activity} />}
      content={<Content activity={activity} />}
      height="auto"
      role="dialog"
    />
  )
}

export default StatusTrackerTipsModal
